import React from "react";
import { Calendar } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

import { OPCOES_PERIODO } from "../lib/periodo";

// Barra de período de cada seção (estado vem de usePeriodo).
export default function FiltroPeriodo({ filtro, setFiltro, dataInicio, setDataInicio, dataFim, setDataFim }) {
  return (
    <div className="bg-card rounded-xl border p-4" data-e2e="filtro-periodo">
      <div className="flex flex-wrap items-center gap-2">
        <Calendar className="w-4 h-4 text-muted-foreground" />
        <span className="text-sm font-medium text-muted-foreground mr-2">Período:</span>
        {OPCOES_PERIODO.map((f) => (
          <Button key={f.key} variant={filtro === f.key ? "default" : "outline"} size="sm" onClick={() => setFiltro(f.key)}>
            {f.label}
          </Button>
        ))}
      </div>
      {filtro === "custom" && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div>
            <label className="text-sm font-medium mb-1 block">Data Início</label>
            <Input type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} />
          </div>
          <div>
            <label className="text-sm font-medium mb-1 block">Data Fim</label>
            <Input type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} />
          </div>
        </div>
      )}
    </div>
  );
}
